var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRailsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1480",
    style: {
      enableBackground: "new 0 0 1500 1480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M889.2,1479.1c-243,0-486.1,0-729.1,0c5.4-92.3,5-185.3,17.3-276.6c33.3-247.8,128.9-474.2,249.8-691 C491.3,396.7,569.3,293.6,677,215.9c144.2-104.1,304.3-148.8,480.5-114.4c131.9,25.8,242.7,95.4,341.6,184.6c0,2.2,0,4.4,0,6.6 c-11.2,12.5-22.5,24.9-34.3,38.1c-10.4-7.5-19.3-13.8-28.2-20.2c-72.6-52.6-154-65.6-239.3-45.6c-231.8,54.5-410.5,277.4-427.9,523 c-11.5,161.8,9.1,319.2,51.5,474.4C840.8,1335.3,866.2,1406.9,889.2,1479.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1,1213.9c5.5-33.3,11-66.5,17.2-104.2c44.2,3.4,89.6,6.8,139.6,10.6c-8.3,48-16,92.8-24.2,140.6 c-45.7-4.8-89.1-9.3-132.6-13.9C1,1236,1,1225,1,1213.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M968.7,0.9c27.2,3,54.3,6,86,9.5c3,19.9,6.4,41.9,10.2,67.2c-38.7,0-73.4,0-112.8,0c-3.2-25-6.6-50.9-9.9-76.7 C951.1,0.9,959.9,0.9,968.7,0.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M840,1245.2c39.2,0,73.1-0.5,106.9,0.5c6.1,0.2,14.7,5.5,17.6,10.9c15.1,28.8,28.8,58.4,45.4,92.8 c-45.9-2.2-86.3-3.1-126.5-6.8c-7.8-0.7-18.1-10.9-21.1-18.9C853.7,1300.1,848.3,1275.5,840,1245.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M915.2,1046.9c-36.6-15.8-69.7-29.6-102.4-44.6c-4.6-2.1-9.5-9.3-9.7-14.3c-1-25.8-0.5-51.7-0.5-87.3 c39.5,21,70.3,36.2,99.6,54c5.8,3.5,6.7,17.1,7.7,26.2C912.3,1001.3,913.3,1021.8,915.2,1046.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M896.9,797.4c-29.3-25.4-58-50.3-87.7-76c11.9-23.9,22.9-46.1,34.6-69.7c11.1,8,88.8,73.6,88.8,73.6 S932.7,725.3,896.9,797.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M896.5,474.1l52.9-48l58.3,66.2l-33.4,66C948.4,530.3,922.5,502.2,896.5,474.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1067.8,336.6c19.3-4.9,49-17.5,49-17.5l27.2,45.8c0,0-27.1,24.8-41.2,35.9 C1091.1,379.3,1080.7,360.2,1067.8,336.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1370.9,347.3c-20.4-1.9-40.8-3.8-63.2-5.9c-0.9-12.6-1.7-23.2-2.5-33.8c32,0.3,54.7,4.7,54.7,4.7L1370.9,347.3 z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.9,763c14.1-39.2,27-74.9,41.2-114.4c41.3,16.2,80.5,31.7,123.8,48.7c-12.3,36-24.1,70.4-36.5,106.7 C197.6,790,157.2,777.1,112.9,763z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.4,368.9c26.6-29.6,50-55.7,76-84.7c30.9,20.3,61.4,40.4,94.2,62c-24.7,30.5-47.3,58.3-71.3,88 C388.3,412.4,357.3,391.9,322.4,368.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M772,120.1c-32.8,19-61.1,35.3-90.3,52.2c-21.6-26.6-41.4-51-64.1-78.9c31-16.4,57.8-30.6,87.7-46.5 C726.8,70.6,747.9,93.7,772,120.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1379.2,169.3l-67.8-43.7l12.1-34.7c26.4,19.5,50.3,36.3,72.8,54.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailsDark);
export default __webpack_public_path__ + "static/media/rails_dark.9cbdfc121e72108257c0126cd5879d8d.svg";
export { ForwardRef as ReactComponent };